import Component from './Component';
import React from 'react';
import ReactDOM from 'react-dom';

export default class ImagePaste extends Component {

	constructor() {
		super();
		this.state = {
			active: false
		}
	}

	componentDidMount() {

		$(ReactDOM.findDOMNode(this)).pasteImageReader((results) => {
			const dataURL = results.filename;
			const filename= results.dataURL;
			results.file.size;
			results.file.type;

			/*var $data, $size, $type, $test, $width, $height;

			/*var img = document.createElement('img');
			img.src= dataURL;
			var w = img.width;
			var h = img.height;*/
			//results.dataURL
			console.log('xx');

		});
	}

	handleFocus() {
		this.setState({active: true});
	}

	handleBlur() {
		this.setState({active: false});
	}

	render() {
		return (
			<div tabIndex="0" className={'pasteimageactive'}
				 onClick={() => this.handleFocus()}
				 onBlur={() => this.handleBlur()}>

				{this.props.children}

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/ImagePaste.js